import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/authentication/services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TokenGuardService implements CanActivate {

  constructor(private authService: AuthService) { }

  canActivate(route: any, state: RouterStateSnapshot): boolean {
    const token = this.authService.getToken();

    if (token) {
      return true;
    }

    // No token — redirect to SSO, same as AuthGuardService
    const baseUrl = window.location.origin;

    let id: string;
    if (!localStorage.getItem('CSRF')) {
      id = crypto.randomUUID();
      localStorage.setItem('CSRF', id);
    } else {
      id = localStorage.getItem('CSRF');
    }

    window.location.href =
      environment.ssoApiUrl +
      'sso/authorize?client_id=cb-sales&redirect_uri=' +
      baseUrl +
      '/auth/callback&state=' +
      id +
      '&prompt=none';

    return false;
  }
}
